import { getHttpService } from 'web_core_library';
import * as UnityEngine from 'web_unity_engine';
import { UnityPath } from '../base/env';

export function createConfigService() {
  let basePath = UnityPath;
  const http = getHttpService(basePath);
  const getBasePath = () => `${basePath}`;
  const setBasePath = (newPath: string) => {
    basePath = newPath;
    http.setBaseURL(newPath);
  };
  const getUnityAppConfig = () => {
    return http.get<UnityEngine.UnityEngineAppConfig>('/Configs/AppConfig.json');
  };
  const getWorkoutSettings = (name: string) => {
    const settingsUrl = `/Configs/${name}/Settings_A.json`;
    return http.get<UnityEngine.UnityEngineExerciseSettings>(settingsUrl);
  };
  const service = {
    getBasePath,
    setBasePath,
    getUnityAppConfig,
    getWorkoutSettings,
  };
  return service;
}

const ConfigService = createConfigService();
export default ConfigService;
